import {
    checkGiftCardBalance,
    giftCardFormData,
    giftCardError
} from '../actions/helpActions';
import { checkForm, shouldActivateParsley } from '../../../core/js/utils/errorHandling';

import template from 'giftcard/balance.j2';

import { debug, error } from '../../../core/js/utils/logger';
import { isRecaptchaEnabledForSlug } from '../utils/utils';

import { generate, templateLocationExists } from '../../../core/js/utils/componentUtils';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';

import { scrollToElement } from '../../../core/js/utils/scrollUtils';
import { GIFT_CARD_BALANCE_SUBMIT_EVENT } from '../../../core/js/constants';

export function onStateChange(store, watchValue, oldVal, newVal) {
    if (oldVal.balance !== newVal.balance) {
        scrollToElement('.js-module-title');
    }

    this.render(store, this, {});
}

/**
 * Attach component events to DOM
 * @param {object} store The redux store
 * @returns {undefined}
 */
export function attachEvents(store) {
    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-gift-card-balance-form'), (e) => {
        e.preventDefault();

        if (isRecaptchaEnabledForSlug(store)) {
            if (window.grecaptcha) {
                window.grecaptcha.reset();
                window.grecaptcha.execute();
            } else {
                error('Gift Card Balance Error: grecaptcha is undefined');
                store.dispatch(giftCardError());
            }
        } else {
            document.dispatchEvent(new CustomEvent(GIFT_CARD_BALANCE_SUBMIT_EVENT));
        }
    });

    document.addEventListener(GIFT_CARD_BALANCE_SUBMIT_EVENT, (e) => {
        debug(`eventListener: ${GIFT_CARD_BALANCE_SUBMIT_EVENT}`);

        const token = _.get(e, 'detail');
        const cardNumber = $('[name=cardNumber]').val();
        const pin = $('[name=pin]').val();

        store.dispatch(checkGiftCardBalance(cardNumber, pin, token));
    });
}

function attachParsley(component, store) {
    $(component.scopedSelector('.js-gift-card-balance-form')).parsley().on('field:validated', () => {
        const [values, msgs] = checkForm(component.scopedSelector('.js-gift-card-balance-form'));

        let previousMsgs = {};

        if (store.getState().core.modal.forgotPassword) {
            previousMsgs = store.getState().core.modal.forgotPassword.messages;
        }
        store.dispatch(giftCardFormData(values, msgs, previousMsgs));
    });
}

function firstRender(store) {
    this.render(store, this);

    if (shouldActivateParsley('.js-gift-card-balance-form')) {
        attachParsley(this, store);
    }
}

/**
 * Bootstrap the component onto the page
 * @param {object} store The redux store
 * @param {object} overrides Component-level overrides config
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-gift-card-balance',
        watch: 'help.giftCard',
        name: 'giftCardBalanceComponent',
        attachEvents: attachEvents,
        onStateChange: onStateChange,
        firstRender: firstRender,
        template: template,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals,
        isComponentValid: templateLocationExists
    };

    return generate(config, store, overrides);
}

window.giftCardRecaptchaSubmit = function(token) {
    debug(`gift card recaptcha token: ${token}`);

    const recaptchaCustomEvent = new CustomEvent(
        GIFT_CARD_BALANCE_SUBMIT_EVENT,
        { 'detail': token }
    );
    document.dispatchEvent(recaptchaCustomEvent);
};
